// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2nAoM","shimmer":"styles_shimmer__3mUKp"};